import { produce } from "immer";
import BODY_REGIONS_FALLBACK from "../../Components/BodyMap/bodyRegions.generated";
import { setActiveBodyRegions } from "../../Components/BodyMap/bodyRegions";
import {
  FETCH_BODY_REGIONS,
  FETCH_BODY_REGIONS_FAILURE,
  FETCH_BODY_REGIONS_SUCCESS,
} from "./constants";

/**
 * The body-map payload (regions + artwork + legacy map) from GET /api/body-regions.
 *
 * Seeded from the bundled generated copy so the map has geometry to draw before
 * the first request resolves — and still has it if that request never does. The
 * live payload replaces it in place; `version` is the API's content hash of the
 * whole thing, so a change to any region, shape or alias invalidates the cache.
 */
export const initialState = {
  isFetching: false,
  payload: BODY_REGIONS_FALLBACK,
  version: BODY_REGIONS_FALLBACK.version,
  isLive: false,
};

const BodyRegionsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_BODY_REGIONS:
        draft.isFetching = true;
        break;
      case FETCH_BODY_REGIONS_SUCCESS: {
        const payload = action.payload;
        draft.isFetching = false;
        if (payload?.regions && payload?.shapes && payload?.order) {
          // Pure helpers (labels, legacy resolution) read the payload
          // synchronously from outside React — keep them on the same copy.
          setActiveBodyRegions(payload);
          draft.payload = payload;
          draft.version = payload.version;
          draft.isLive = true;
        }
        break;
      }
      case FETCH_BODY_REGIONS_FAILURE:
        draft.isFetching = false;
        break;
      default:
        return state;
    }
  });

export default BodyRegionsReducer;
